module.exports = __webpack_public_path__ + "static/img/BE@2x.316c0e67.jpg";